// extracted by mini-css-extract-plugin
module.exports = {"player":"BackgroupPlayer_player__1pL4J"};